module.exports = __webpack_public_path__ + "static/media/noInvitations.e3f51773.svg";